function handleHeaderScroll() {
    const header = document.querySelector('header');
    const scrollOffset = 100;

    if (window.scrollY >= scrollOffset) {
        header.classList.add('sticky');
        if (header.classList.contains('inicio')) {
            header.classList.remove('inicio');
            header.classList.add('inicio-disabled');
        }
    } else {
        header.classList.remove('sticky');
        if (header.classList.contains('inicio-disabled')) {
            header.classList.add('inicio');
            header.classList.remove('inicio-disabled');
        }
    }
}

window.addEventListener('scroll', handleHeaderScroll);
